export default "__VITE_ASSET__67b8bd8d__"